import { render, staticRenderFns } from "./NotificationTypeDropdown.vue?vue&type=template&id=17dae310&"
import script from "./NotificationTypeDropdown.vue?vue&type=script&lang=js&"
export * from "./NotificationTypeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports